// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GlobalAlert_Wrapper__6fHPb","Alert":"GlobalAlert_Alert__JbqHC"};